import { EditorState, Modifier } from 'draft-js';
import { PureComponent } from 'react';

import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export default class MergeVarsEditor extends PureComponent {
  state = { name: null, defaultValue: '' };

  confirm = () => {
    const { editorState, onClose, onUpdateEditorState } = this.props;
    const { defaultValue, name } = this.state;
    if (!(name && defaultValue)) return;
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('MERGE_VAR', 'IMMUTIBLE', {
      name,
      defaultValue,
    });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const selection = editorState.getSelection();
    let contentStateWithLinkText = Modifier.replaceText(
      contentStateWithEntity,
      selection,
      ' ' /* zero-width whitespace */,
      null,
      entityKey,
    );

    const newSelection = contentStateWithLinkText.getSelectionAfter();
    const blockKey = newSelection.getAnchorKey();
    const blockSize = contentStateWithLinkText.getBlockForKey(blockKey).getLength();
    if (newSelection.getAnchorOffset() === blockSize) {
      contentStateWithLinkText = Modifier.insertText(contentStateWithLinkText, newSelection, ' ');
    }

    const editorStateWithLinkText = EditorState.set(editorState, {
      currentContent: contentStateWithLinkText,
    });

    onUpdateEditorState(
      EditorState.forceSelection(editorStateWithLinkText, contentStateWithLinkText.getSelectionAfter()),
    );
    onClose();
  };

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.confirm();
    }
  };

  render() {
    const { anchorEl, onClose, onExited, options, show } = this.props;
    const { defaultValue, name } = this.state;
    return (
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        disableRestoreFocus
        onClose={onClose}
        open={show}
        slotProps={{ transition: { onExited } }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div css={rootCss}>
          <Typography align="center" variant="h4">
            Merge Variable
          </Typography>
          <TextField
            fullWidth
            margin="normal"
            onChange={e => this.setState({ name: e.target.value })}
            select
            slotProps={{ select: { displayEmpty: true } }}
            value={name || ''}
            variant="standard"
          >
            <MenuItem value="">
              <em>Select Variable</em>
            </MenuItem>
            {Object.keys(options).map((name, i) => (
              <MenuItem key={i} value={name}>
                {options[name]}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            margin="normal"
            onChange={e => this.setState({ defaultValue: e.target.value })}
            onKeyDown={this.handleKeyDown}
            placeholder="Default Value"
            value={defaultValue}
            variant="standard"
          />
          <div className="MVE-actionBtn">
            <Button onClick={this.confirm} variant="text">
              Done
            </Button>
          </div>
        </div>
      </Popover>
    );
  }
}

const rootCss = ({ spacing }) => ({
  minWidth: 200,
  padding: spacing(1, 2),
  '.MVE-actionBtn': {
    textAlign: 'center',
  },
});
